import * as React from 'react';
export const IcDocumentSettings = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 7h4c0-.53-.21-1.04-.59-1.41l-3-3C16.03 2.21 15.53 2 15 2v4c0 .55.45 1 1 1zm-4 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm1-7V2H7.5A2.5 2.5 0 005 4.5v15A2.5 2.5 0 007.5 22h10a2.5 2.5 0 002.5-2.5V9h-4c-1.65 0-3-1.35-3-3zm3.58 6.93c.28.48.11 1.09-.37 1.37l-.27.16c.02.18.06.36.06.55 0 .19-.03.37-.06.55l.27.16c.48.28.64.89.37 1.37l-.5.87c-.28.48-.89.64-1.37.37l-.27-.16c-.29.23-.6.42-.94.56v.3c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-.3c-.34-.14-.66-.33-.94-.56l-.27.16c-.48.28-1.09.11-1.37-.37l-.5-.87c-.28-.48-.11-1.09.37-1.37l.27-.16c-.02-.18-.06-.36-.06-.55 0-.19.03-.37.06-.55l-.27-.16a1.01 1.01 0 01-.37-1.37l.5-.87c.28-.48.89-.64 1.37-.37l.27.16c.29-.23.6-.42.94-.56v-.3c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v.3c.34.14.66.33.94.56l.27-.16c.48-.28 1.09-.11 1.37.37l.5.87z'
      fill='currentColor'
    />
  </svg>
);
